if (!customElements.get('diwali-what-makes-special')) {
  customElements.define('diwali-what-makes-special', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.diwali-special__item')];
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.refresh = () => this.configure();
      this.schedule = () => {
        if (!this.enabled || !this.visible || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.render();
        });
      };
      this.select = event => {
        this.selected = event.target.closest('.diwali-special__item');
        this.render();
      };
      this.deselect = () => {
        this.selected = null;
        this.render();
      };
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { rootMargin: '100px' });
      this.observer.observe(this);
      this.mobile.addEventListener('change', this.refresh);
      this.reduced.addEventListener('change', this.refresh);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.refresh, { passive: true });
      this.addEventListener('shopify:block:select', this.select);
      this.addEventListener('shopify:block:deselect', this.deselect);
      this.configure();
    }

    configure() {
      this.enabled = this.mobile.matches && !this.reduced.matches && this.dataset.motion === 'true';
      this.classList.toggle('is-motion', this.enabled);
      if (this.enabled) this.render();
      else this.items.forEach(item => item.style.removeProperty('--dsp-reveal'));
    }

    render() {
      if (!this.enabled) return;
      const height = window.innerHeight;
      this.items.forEach(item => {
        const top = item.getBoundingClientRect().top;
        const progress = Math.max(0, Math.min(1, (height * 0.94 - top) / (height * 0.26)));
        const ease = progress * progress * (3 - 2 * progress);
        item.style.setProperty('--dsp-reveal', item === this.selected ? '1' : String(ease));
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.refresh);
      this.reduced?.removeEventListener('change', this.refresh);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.refresh);
      this.removeEventListener('shopify:block:select', this.select);
      this.removeEventListener('shopify:block:deselect', this.deselect);
      cancelAnimationFrame(this.frame);
    }
  });
}
